module.exports = __webpack_public_path__ + "img/Arsat2.687ea1ac.jpg";